const topics = [
  { name: '明星塌房', count: '2,847', hot: true },
  { name: '综艺争议', count: '1,956', hot: true },
  { name: '网红翻车', count: '1,634', hot: true },
  { name: '娱乐圈内幕', count: '1,289', hot: false },
  { name: '影视吐槽', count: '2,103', hot: true },
  { name: '带货翻车', count: '1,478', hot: false },
  { name: '饭圈大战', count: '3,251', hot: true },
  { name: '选秀黑料', count: '967', hot: false },
  { name: '恋情曝光', count: '1,845', hot: true },
  { name: '合约纠纷', count: '1,102', hot: false },
  { name: '私生饭事件', count: '753', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">热门话题</h2>
          <p className="text-sm text-foreground-500">大家都在讨论的热门吃瓜话题标签</p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#topics"
              onClick={(e) => e.preventDefault()}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full transition-all duration-200 hover:scale-105 cursor-pointer whitespace-nowrap ${
                t.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              <span className="text-sm font-semibold">{t.name}</span>
              <span className={`text-xs font-mono ${t.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {t.count}
              </span>
              {t.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
              )}
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}